const finite=value=>typeof value==='number'&&Number.isFinite(value);
const round=value=>Math.round((value+Number.EPSILON)*100)/100;
function saleMetrics({hammerGBP,costGBP,vatPurchaseGBP=null}){
 const hammer=finite(hammerGBP)&&hammerGBP>0?hammerGBP:null;
 const cost=finite(costGBP)&&costGBP>=0?costGBP:null;
 const gross=hammer!==null&&cost!==null?round(hammer-cost):null;
 const purchase=finite(vatPurchaseGBP)&&vatPurchaseGBP>=0?vatPurchaseGBP:null;
 const vat=hammer!==null&&purchase!==null?round(Math.max(0,hammer-purchase)/6):null;
 const after=gross!==null&&vat!==null?round(gross-vat):null;
 return {grossProfitGBP:gross,grossMarginPercent:gross===null?null:round(gross/hammer*100),vatScenarioGBP:vat,
  afterVatProfitGBP:after,afterVatMarginPercent:after===null?null:round(after/(hammer-vat)*100),vatPurchaseGBP:purchase};
}
module.exports={saleMetrics,round};
